import { JobsConfigData, v5 } from '@contracts'
import type { SanitisedProductData, SanitisedBrandData } from './AiOutput.d'
import { CategoriesDetailData } from '../../../../../dist/libs/api-contracts/lib/generated/v5/data-contracts'

export const sanitiseCategoryData = (categoryData?: any): CategoriesDetailData => {
  return {
    _id: categoryData?._id,
    gpc_level: categoryData?.gpc_level,
    gpc_code: categoryData?.gpc_code,
    origin_id: categoryData?.origin_id,
    required_attributes: categoryData?.required_attributes,
    guidelines: categoryData?.guidelines,
    content_blocks: categoryData?.content_blocks?.map((block: any) => ({
      id: block.id,
      title: block.title || '',
      properties: {
        highlighted_attributes: block.properties?.highlighted_attributes,
        tasks: block.properties?.tasks,
        guidelines: block.properties?.guidelines,
        character_limit: block.properties?.character_limit,
        pattern: block.properties?.pattern,
      },
    })),
    version: categoryData?.version_used,
    update_info: categoryData?.update_info
      ? {
          type: categoryData.update_info.type,
          from_version: categoryData.update_info.from_version,
          user_name: categoryData.update_info.user_name,
          comment: categoryData.update_info.comment,
        }
      : undefined,
    created_at: categoryData?.created_at,
    updated_at: categoryData?.updated_at,
    archived: categoryData?.archived,
  }
}

export const sanitiseRetailerData = (retailerData: v5.VersionDetailOutput): v5.RetailersDetailData => {
  return {
    _id: retailerData?._id,
    name: retailerData?.name,
    channel: retailerData?.channel,
    guidelines: retailerData?.guidelines,
    omit_keywords: retailerData?.omit_keywords,
    archived: retailerData?.archived,
    created_at: retailerData?.created_at,
    updated_at: retailerData?.updated_at,
    content_blocks: retailerData?.content_blocks?.map(block => ({
      id: block.id,
      title: block.title || '',
      properties: {
        apply_to_categories: block.properties?.apply_to_categories,
        character_limit: block.properties?.character_limit,
        guidelines: block.properties?.guidelines,
        pattern: block.properties?.pattern,
      },
    })),
    update_info: retailerData?.update_info
      ? {
          comment: retailerData.update_info.comment,
          from_version: retailerData.update_info.from_version,
          type: retailerData.update_info.type,
          user_name: retailerData.update_info.user_name,
        }
      : undefined,
  }
}

export const sanitiseProductData = (regionalData: JobsConfigData['product']): SanitisedProductData => {
  // Remove _id, created_at, and updated_at, review and attributes
  const { attributes, keywords } = regionalData!

  // Sanitise attributes
  const sanitisedAttributes: Record<string, string> = {}
  attributes?.forEach(attribute => {
    if (!attribute.name || !attribute.value) return
    sanitisedAttributes[attribute.name] = attribute.value
  })

  // Create sanitised data structure
  const sanitisedRegionalData = {
    regional_product_information: {
      ...sanitisedAttributes,
    },
    keywords: keywords,
  }

  return sanitisedRegionalData
}

export const sanitiseBrandData = (brandData: JobsConfigData['brand']): SanitisedBrandData => {
  const sanitisedBrandData = {
    brand_rules: {
      ...brandData?.config?.content_config,
    },
  }

  return sanitisedBrandData
}
